<template>
    <div class="search-component" :class="{'with-search-list': showSearchList}">
        <InputDropdown v-if="showSearchList"
                       :saturn.sync="toSearch"
                       :list="[{key: 'all', label: 'All'}, ...searchKeys]"
                       :value="(d) => d.key"
                       :text="(d) =>  d.label"></InputDropdown>
        <InputTextbox :showIcon="false" :saturn.sync="searchValue" @keyEnter="filterResultsDown">
            <template #action>
                <div class="reset-text" v-if="searchValue && searchValue != ''" @click="resetTextHandler"><i class="fas fa-times-circle"></i></div>
            </template>
        </InputTextbox>
        <button @click="filterResultsDown">Search</button>

    </div>
</template>


<script>
    import InputDropdown from '@/components/InputDropdown'
    import InputTextbox from '@/components/InputTextbox'
    import EventBus from '@/services/event-bus'

    export default {
        name: "SearchComponent",
        props: ['searchKeys', 'data', 'output', 'searchByFilter', 'tableRow'],
        data() {
            return {
                toSearch: 'all',
                searchValue: null,
            };
        },
        computed: {
            showSearchList() {
                return this.searchKeys && this.searchKeys.length != 0;
            }
        },
        created() {
            this.$emit('update:output', this.data);

            if (!(this.searchKeys || this.searchByFilter)) {
                throw 'SearchComponent missing searchKeys or searchByFilter Props';
            } else if (this.searchKeys && this.searchByFilter) {
                console.warn('SearchComponent has both searchKeys and searchByFilter Props. Only one will be used (searchKeys).')
            }

            EventBus.$on('SearchComponent_Reset', this.resetTextHandler);
            this.$once("hook:beforeDestroy", () => {
                EventBus.$off('SearchComponent_Reset', this.resetTextHandler);
            });
        },
        mounted() {
        },
        methods: {
            resetTextHandler() {
                this.searchValue = '';
                this.filterResultsDown()
            },
            filterResultsDown() {
                let output2 = []

                //PRIMARY FILTER FUNCTION
                let outputFilterFunction = (row, searchKey) => {
                    let value = searchKey.value ? searchKey.value(row) : row[searchKey.key]
                    return (row && value && value.toString().toLowerCase().includes(this.searchValue.toLowerCase()));
                };

                if (this.searchValue) {

                    if (this.searchKeys) {
                        if (this.toSearch == 'all') {
                            output2 = this.data.filter(d => d && this.searchKeys.some(sK => outputFilterFunction(d, sK)))
                        } else {
                            let searchKey = this.searchKeys.find(sK => sK.key == this.toSearch);
                            output2 = this.data.filter(d => outputFilterFunction(d, searchKey));
                        }
                    }
                    else if (this.searchByFilter) {
                        output2 = this.data.filter(d => d && this.searchByFilter(d, this.searchValue));
                    }
                } else {
                    output2 = this.data
                }







                this.$emit('update:output', output2);
                this.$emit('onSearch')
            }

        },
        components: {
            InputTextbox,
            InputDropdown
        }
    };
</script>
<style>
    .search-component {
        display: flex;
    }

        .search-component .reset-text {
            padding: 7px 9px;
            font-size: 16px;
            -webkit-text-stroke-color: var(--disabled-color);
            -webkit-text-stroke-width: 1px;
            color: var(--background-color);
            margin-top: -1px;
            margin-right: -1px;
        }

            .search-component .reset-text:hover {
                cursor: pointer;
                -webkit-text-stroke-width: 0;
                color: var(--background-color);
                text-shadow: 0 0 3px var(--black-30percent);
                background: var(--disabled-color);
            }


        .search-component button {
            width: auto;
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
        }

        .search-component input {
            flex-grow: 1;
            width: auto;
            border-radius: 0 !important;
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
        }

        .search-component.with-search-list input {
            border-radius: 0 !important;
        }

        .search-component.with-search-list select {
            border-radius: 0 !important;
        }
</style>